// The faces public/index.html actually registers, so the hero renders the design's fonts:
// - Inter Bold is registered at font-weight 600 (Black at 900), so asking for 700 resolves to the
//   next heavier face and renders Inter Black. "Inter:Bold" in Figma is weight 600 here.
// - IBM Plex Mono is registered as "IBM Mono" (Bold at 600); under its own name it only resolves
//   where it happens to be installed locally, and falls back to the system monospace elsewhere.

export const INTER = "'Inter', sans-serif";
/** Figma "Inter:Bold". */
export const INTER_BOLD = 600;
/** Figma "Inter:Black". */
export const INTER_BLACK = 900;

export const MONO = "'IBM Mono', 'IBM Plex Mono', monospace";
/** Figma "IBM Plex Mono:Bold". */
export const MONO_BOLD = 600;
